export enum EmployeeRoleEnum {
  Manager = 2,
  Waiter = 3
}
